<template>
  <el-dialog
    v-el-drag-dialog
    no="dialog"
    :visible.sync="innerVisible"
    :title="$t('queryJob.receivingOutsideWarehouse')"
    width="1055px"
    :close-on-click-modal="false"
  >
    <div class="app-main-content">
      <div class="details-view">
        <div class="main-content">
          <div class="section">
            <span class="title">{{ $t('CargoMsg.Cargo_BasicInfo') }}</span>
            <el-form :inline="true" label-width="80px">
              <el-form-item>
                <span class="blue">{{ $t('queryJob.warehousingTime') }}</span>
                <el-date-picker
                  v-model="warehouseIn.warehouseInDate"
                  no="warehouseInDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 120px;"
                />
                <el-checkbox v-model="warehouseIn.broken" style="margin: 0 10px;">{{ $t('queryJob.damagedAndDamp') }}</el-checkbox>
                <el-input-number
                  v-model="warehouseIn.brokenQuantity"
                  no="brokenQuantity"
                  :disabled="!warehouseIn.broken"
                  controls-position="right"
                  :precision="0"
                  :min="0"
                  :max="9999"
                  style="width: 120px;"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section">
            <span class="title">{{ $t('queryJob.size') }}</span>
            <warehouse-detail-grid
              ref="detailGrid"
              :context="{}"
              action="look"
              :job="job"
              :warehouse-in="warehouseIn"
              :display-summary="false"
            />
          </div>
          <div class="section">
            <span class="title">{{ $t('queryJob.photo') }}</span>
            <warehouse-pic-grid
              ref="picGrid"
              :model="warehouseIn"
              :show-buttons="false"
              @uploadDone="uploadDoneHandler"
            />
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" style="display: flex;">
      <el-button no="selectPhotos" type="primary" @click="$refs.picGrid.selectHandler()">{{ $t('queryJob.selectPhotos') }}</el-button>
      <el-button no="deletePhotos" type="primary" @click="$refs.picGrid.deleteHandler()">{{ $t('queryJob.deletePhotos') }}</el-button>
      <div style="flex-grow: 1;" />
      <el-button no="Confirm" type="primary" @click="enterHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import warehouseDetailGrid from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/components/warehouseDetailGrid'
import warehousePicGrid from './warehousePicGrid'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { saveWarehouseInForAe } from '@/api/seaExport/warehouseIn'

export default {
  name: 'WarehouseEntryDialog',
  components: { warehouseDetailGrid, warehousePicGrid },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      warehouseIn: new WarehouseIn().fillDefaultValue().getData()
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.job.warehouseIn && this.job.warehouseIn.length > 0) {
          this.warehouseIn = this.job.warehouseIn[0]
        } else {
          new WarehouseIn(this.warehouseIn).fillDefaultValue()
          this.warehouseIn.jobUuid = this.job.uuid
        }
        this.$nextTick(() => {
          this.$refs.detailGrid.fillView()
          this.$refs.picGrid.init()
        })
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async enterHandler() {
      const job = this.job
      const warehouseIn = this.warehouseIn
      if (!warehouseIn.warehouseInDate) {
        this.$message.info(this.$t('queryJob.selectWarehousingDate'))
        return
      }

      /* 保存尺码 */
      if (!job.warehouseNo) {
        this.warehouseIn.warehouseNo = job.jobNo
        job.warehouseNo = job.jobNo
      } else {
        warehouseIn.warehouseNo = job.warehouseNo
      }
      warehouseIn.warehouseInDate = new Date()
      const warehouseInDetail = this.$refs.detailGrid.rowData
      for (const detail of warehouseInDetail) {
        detail.warehouseInUuid = warehouseIn.uuid
      }
      warehouseIn.jobUuid = job.uuid
      warehouseIn.warehouseInDetail = warehouseInDetail
      await saveWarehouseInForAe(warehouseIn)

      // 上传照片
      this.$refs.picGrid.upload()
    },
    uploadDoneHandler() {
      this.$refs.picGrid.submit().then(() => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
        this.$emit('callback')
      })
    }
  }
}
</script>
